import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

export type SettingsRowFrameProps = {
  children: ReactNode
  showDivider?: boolean
  className?: string
  innerClassName?: string
}

/**
 * Shared inset divider + horizontal padding for all settings rows.
 * `border-b` lives on the inner box so lines align with Account settings rows.
 */
export function SettingsRowFrame({
  children,
  showDivider = true,
  className,
  innerClassName,
}: SettingsRowFrameProps) {
  return (
    <div className={cn('px-4', className)}>
      <div className={cn(showDivider && 'border-b', innerClassName)}>{children}</div>
    </div>
  )
}
